import * as CookieConsent from 'vanilla-cookieconsent';
import { gsap } from '../global/gsap';

const initSplash = (element) => {
    const body = document.querySelector('body');
    const header = document.querySelector('header');
    const headerPartner = document.querySelector('.header__partner-logo');
    const headerNotice = document.querySelector('.header__notice');
    const headerLogo = document.querySelector('.header__site-link svg');
    const headerButton = document.querySelector('.header__link');
    const video = element.querySelector('video');
    const bgMedia = document.querySelector('.js-bg-media');
    const splashSkip = document.querySelector('.js-splash-skip');

    const splashPlayed = sessionStorage.getItem('splashShown');

    if (!splashPlayed && video) {
        video.play();

        bgMedia.classList.remove('is-hidden');

        gsap.set(headerPartner, {
            opacity: 0,
            xPercent: -150,
        });
        gsap.set(headerNotice, {
            opacity: 0,
            animationPlayState: 'paused',
        });

        gsap.set(headerButton, {
            xPercent: 150,
        });

        gsap.set(headerLogo, {
            yPercent: -150,
        });

        const tl = gsap.timeline({
            onStart: () => {
                header.classList.add('has-grad');
            },
            onComplete: () => {
                element.remove();
                body.classList.remove('stop-scrolling');
                sessionStorage.setItem('splashShown', true);
                // Check if cookie manager hasn't been responded to
                if (
                    !document.cookie
                        .split(';')
                        .some((item) => item.trim().startsWith('cc_cookie='))
                ) {
                    CookieConsent.show();
                }
            }
        });
        tl.pause();
        tl.to(splashSkip, {
            autoAlpha: 0
        })
        tl.to(element, {
            autoAlpha: 0,
            duration: 0.3,
        });
        tl.to(headerPartner, {
            opacity: 1,
            xPercent: 0,
            ease: 'power3.inOut'
        }, '<');
        tl.to(headerNotice, {
            opacity: 1,
            animationPlayState: 'running',
            duration: 0.5,
            ease: 'power3.inOut',
        });
        tl.to(headerLogo, {
            yPercent: 0,
            duration: 0.9,
            ease: 'power3.inOut'
        }, '<');
        tl.to(
            headerButton, {
                xPercent: 0,
                duration: 0.7,
                ease: 'power3.inOut'
            }, '<'
        );

        body.classList.add('stop-scrolling');
        video.addEventListener('ended', () => {
            tl.play();
        });
        const skipTl = () => {
            tl.play();
        };

        splashSkip.addEventListener('click', () => {
            skipTl();
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                skipTl();
            }
        });
    } else {
        header.classList.add('has-grad');
        bgMedia.classList.remove('is-hidden');
        element.remove();
    }
};

export default initSplash;
